import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import SkinTypeQuiz from "@/pages/SkinTypeQuiz";
import Dashboard from "@/pages/Dashboard";
import Protocol from "@/pages/Protocol";
import Analyze from "@/pages/Analyze";
import ProductResult from "@/pages/ProductResult";
import Library from "@/pages/Library";
import Readiness from "@/pages/Readiness";
import RetinoidAugmentation from "@/pages/RetinoidAugmentation";
import VitaminCReadiness from "@/pages/VitaminCReadiness";
import Tracker from "@/pages/Tracker";
import PrecisionCorrections from "@/pages/PrecisionCorrections";
import ProtocolSummary from "@/pages/ProtocolSummary";
import HowItWorks from "@/pages/HowItWorks";
import ApplicationTips from "@/pages/ApplicationTips";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/skin-type-quiz" element={<Protected><SkinTypeQuiz /></Protected>} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/dashboard" element={<Protected requireOnboarded><Dashboard /></Protected>} />
          <Route path="/protocol" element={<Protected requireOnboarded><Protocol /></Protected>} />
          <Route path="/analyze" element={<Protected requireOnboarded><Analyze /></Protected>} />
          <Route path="/products/:id" element={<Protected requireOnboarded><ProductResult /></Protected>} />
          <Route path="/library" element={<Protected requireOnboarded><Library /></Protected>} />
          <Route path="/readiness" element={<Protected requireOnboarded><Readiness /></Protected>} />
          <Route path="/retinoid-augmentation" element={<Protected requireOnboarded><RetinoidAugmentation /></Protected>} />
          <Route path="/vitamin-c-readiness" element={<Protected requireOnboarded><VitaminCReadiness /></Protected>} />
          <Route path="/tracker" element={<Protected requireOnboarded><Tracker /></Protected>} />
          <Route path="/precision-corrections" element={<Protected requireOnboarded><PrecisionCorrections /></Protected>} />
          <Route path="/summary" element={<Protected requireOnboarded><ProtocolSummary /></Protected>} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/application-tips" element={<ApplicationTips />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
